import { ADMIN_USERROLE_ACTIONS } from "../../../actionType/admin/usersRole";

  
  const intialState = {
    userRoleListData: [],
    isUserRolesListLoader: false,
    userRoleEditData: {},
    isUserRolesEditLoader: false,

  };
  
  export const adminUserRoleReducer = (
    state = intialState,
    { type, payload }: any
  ) => {
    switch (type) {
      case ADMIN_USERROLE_ACTIONS.USERROLE_LIST_REQUEST:
        return { ...state, isUserRolesListLoader: true };
      case ADMIN_USERROLE_ACTIONS.USERROLE_LIST_RESPONSE:
        return {
          ...state,
          userRoleListData: payload,
          isUserRolesListLoader: false,
        };
      case ADMIN_USERROLE_ACTIONS.USERROLE_LIST_ERROR:
        return {
          ...state,
          userRoleListData: payload,
          isUserRolesListLoader: false,
        };


        case ADMIN_USERROLE_ACTIONS.USERROLE_LIST_REQUEST:
          return { ...state, isUserRolesEditLoader: true };
        case ADMIN_USERROLE_ACTIONS.USERROLE_LIST_RESPONSE:
          return {
            ...state,
            userRoleEditData: payload,
            isUserRolesEditLoader: false,
          };
        case ADMIN_USERROLE_ACTIONS.USERROLE_LIST_ERROR:
          return {
            ...state,
            userRoleEditData: payload,
            isUserRolesEditLoader: false,
          };
  
    
      default:
        return state;
    }
  };
  